<template>
  <div class="section-clients" id="clients">
    <div class="container">
      <ui-title class="section-clients__title" text="Наши клиенты" line/>
      <div class="section-clients__content-wrap">
        <div class="section-clients__item">
          <div class="section-clients__item-name">ВТБ Банк</div>
          <div class="section-clients__item-desc">Банк ВТБ является ключевым звеном банковской группы ВТБ и одним из крупнейших банков России. Ключевые направления деятельности — работа с корпоративными клиентами и финансовыми организациями. Наши специалисты учавствовали в реализации важнейших проектов компании: ВТБ Онлайн, Бизнес Онлайн, Нотификационная платформа, Омниканальная платформа.</div>
          <div class="section-clients__item-image">
            <icon-vtb/>
          </div>
        </div>
        <div class="section-clients__item">
          <div class="section-clients__item-name">Сбер</div>
          <div class="section-clients__item-desc">Сбербанк — крупнейший банк в России, Центральной и Восточной Европе, один из ведущих международных финансовых институтов. Специалисты нашей компании принимали участие в развитии ряда сложнейших проектов Сбербанка, среди которых Платформа поддержки развития бизнеса (ППРБ), Единая фронтальная система.</div>
          <div class="section-clients__item-image">
            <icon-sber/>
          </div>
        </div>
        <div class="section-clients__item">
          <div class="section-clients__item-name">Альфа-банк</div>
          <div class="section-clients__item-desc">Альфа-Банк — универсальный банк, осуществляющий все основные виды банковских операций, представленных на рынке финансовых услуг, включая обслуживание частных и корпоративных клиентов, инвестиционный банковский бизнес, лизинг, факторинг и торговое финансирование, является одним из лидеров рынка. Наши специалисты участвовали в развитии таких платформ кредитования, как Матрица кредитных предложений и Альфа-Финанс.</div>
          <div class="section-clients__item-image">
            <icon-alfa/>
          </div>
        </div>
        <div class="section-clients__item">
          <div class="section-clients__item-name">X5 Retail group</div>
          <div class="section-clients__item-desc">Х5 Group — ведущая продуктовая розничная компания России, которая управляет портфелем брендов сетевых магазинов «Пятёрочка», «Перекрёсток», «Карусель», а также цифровыми платформами. У специалистов нашей компании есть опыт работы на ключевых проектах X5 Group таких как, Feedback и HR Portal.</div>
          <div class="section-clients__item-image">
            <icon-retail/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiTitle from '@/components/ui/UiTitle'
import IconVtb from '@/components/icons/IconVtb'
import IconSber from '@/components/icons/IconSber'
import IconAlfa from '@/components/icons/IconAlfa'
import IconRetail from '@/components/icons/IconRetail'

export default {
  components: {
    UiTitle,
    IconVtb,
    IconSber,
    IconAlfa,
    IconRetail,
  },
}
</script>

<style lang="scss">
@import "../../assets/scss/mixins.scss";

.section-clients {
  display: flex;
  justify-content: center;
  padding-bottom: 88px;

  &__title {
    margin-bottom: 39px;
  }

  &__content-wrap {
    display: flex;
    flex-direction: column;
    row-gap: 48px;
    padding-right: 52px;
    border-right: 3px solid #1C3BBD;
    width: 50%;

    @include breakpoint(laptop) {
      border-right: 0;
      padding-right: 10px;
    }

    @include breakpoint(tablet) {
      padding-right: 0;
      width: 55%;
    }

    @include breakpoint(phablet) {
      width: 100%;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    opacity: .3;
    transition: .3s;

    @include breakpoint(phablet) {
      flex-direction: column-reverse;
    }

    &:hover {
      opacity: 1;
    }

    &-name {
      font-weight: 600;
      font-size: 40px;
      line-height: 120%;
      letter-spacing: 0.1px;
      margin-bottom: 16px;

      @include breakpoint(phablet) {
        display: none;
      }
    }
    
    &-desc {
      font-weight: 400;
      color: #1C3BBD;
    }

    &-image {
      position: absolute;
      right: 0;
      align-self: center;
      transform: translateX(calc(95px + 100%));

      @include breakpoint(tablet) {
        height: 102px;
        transform: translateX(calc(40px + 100%));

        svg {
          height: 100%;
          width: 100%;
        }
      }

      @include breakpoint(phablet) {
        right: inherit;
        position: initial;
        align-self: flex-start;
        transform: translateX(0);
        height: 65px;
        width: 205px;
      }

      svg {
        path, ellipse {
          transition: .3s;
        }
      }
    }
  }
}
</style>
